/* src/app/modules/spare-parts/most-consumed-widget/most-consumed-widget.component.scss */
.most-consumed-container {
  display: flex;
  width: 100%;
  height: 3rem;
  margin: 0.5rem 0;
}
.highest-consumed-label {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.description {
  flex: 1;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.most-consumed {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, var(--opacity-6));
  gap: 1rem;
}
.most-consumed sh-text {
  width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=most-consumed-widget.component.css.map */
